<template>
  <footer 
    class=" flex bg-transparent p-2 pb-10 w-screen justify-center z-100"
  > 
    <div 
      class=" inner-footer flex-col-nowrap text-center relative w-full items-center p-4
              md:flex-row-nowrap md:justify-around max-w-screen-lg "
    >
      <div 
        v-if="isVisibleDatos"
        class="w-full text-xl 
        md:w-1/2"
      >
        <datos-contacto  
          class="items-center self-center p-8  whitespace-nowrap 
          md:items-start md:self-start"
          color-iconos="rgba(255, 66, 25, 1)"
        >
        </datos-contacto>
      </div>
      
      <div 
        class="footer-derecha flex flex-col items-center w-full 
              md:w-1/2 md:justify-center md:items-end"
      >
        <social-nav v-if="isVisibleDatos"></social-nav>
        <div 
          class="contenedor-logo w-full relative
          md:absolute"
        >
          <router-link 
            :to="{ name: 'inicio', params: { section: 'inicio' } }"
          > 
            <base-icon 
              icon-name="iconIsotipoLogo"              
              text-color="rgba(255, 66, 25, 1)"
              class="inline-block"
              view-box="0 0 1940 1498"
              width="100%"
              height="100%"
            >
              <icon-isotipo-logo />
            </base-icon>
          </router-link> 
        </div>
        <div 
          class="contenedor-letras-logo relative flex flex-col items-center w-full  mt-4
                md:w-1/2 md:justify-center md:items-end"
        >
          <p 
            class="abriendo-juego text-azul w-fit whitespace-nowrap text-center font-heading font-bold  mr-4
            md:text-right"
          >
            ABRIENDO EL JUEGO
          </p>
          <p 
            class="colectivo w-fit uppercase whitespace-nowrap font-subheading text-center font-extralight text-naranja
            md:text-right md:pb-4 "
          >
            Colectivo de Recreacion Comunitaria
          </p>
        </div>
        <social-nav 
          v-if="!isVisibleDatos"
          color1="rgba(89, 79, 169, 1)"
          color2="rgba(255, 199, 0, 1)"
        ></social-nav>
      </div>
    </div>
  </footer>
</template>

<script>
import SocialNav from '../SocialNav.vue';
import DatosContacto from '../DatosContacto.vue'
// boton de direccion lleva a google maps
export default {
  components: {
    SocialNav,
    DatosContacto
  },
  data() {
    return{ 
      isVisibleDatos: true
    }
  },
  created() {
    this.handleView();
    window.addEventListener("resize", this.handleView);
  },
  // beforeMount() {
  //   console.log("before mount handleVisibility");
  //   window.addEventListener('resize', this.handleView);
  // },
  // beforeUpdate() {
  //   console.log("before update handleVisibility");
  //   console.log("handleVisibility");
  //   this.handleView();
  // },
  methods: {
    handleView() {
      if (window.innerWidth > 768) {
        this.isVisibleDatos = true
      } else {
        this.isVisibleDatos = false
      }
    },
  },
}
</script>

<style scoped>


  footer .contenedor-logo{
      width: 15rem;
    }

    footer p.colectivo {
      font-size: 1.8rem;
      white-space: normal;
      margin-bottom: 1.5rem;
      letter-spacing: 0.03em;
    }

    footer p.abriendo-juego {
      font-size: 1.7rem;
      margin-bottom: 1.5rem;
      margin-right: 0;
    }

    footer .contenedor-letras-logo {
      width: 25rem;
    }

    footer {
      border-top: 5px solid rgb(255, 199, 0);
    }

  @media screen and (max-width: 280px) {
    
    footer p.colectivo {
      font-size: 5vw;
      white-space: normal;
      margin-bottom: 2vw;
    }

    footer p.abriendo-juego {
      font-size: 5.5vw;
      margin-bottom: 2vw;
    }

    footer .contenedor-logo{
      width: 50vw;
    }

  }


  @media screen and (min-width: 768px) {
    .inner-footer{
      width: 90%;
    }
    
    footer .contenedor-logo {
      right: -1vw;
      bottom: 2.5rem;
      width: 20vw;
    }  
    
    footer .contenedor-logo{
      width: 20vw;
    }
    
    footer{
      margin-top: 6vw;
      border-top: none;
    }

    footer p.abriendo-juego {
      letter-spacing: 0.03em;
      font-size: 1.5vw;
      margin-right: 1vw;
      margin-bottom: 0;
    }

    footer p.colectivo {
      font-size: 1vw;
      margin-right: 0vw;
      padding-bottom: 1rem;
      margin-bottom: 0;
      white-space: nowrap;
    }

    footer .contenedor-letras-logo {
      left: -12vw;
      width: 50%;
    }

  }

  @media screen and (min-width: 1024px) {
    .inner-footer{
      width: 100%;
    }

    footer .contenedor-logo {
      right: -1.2rem;
      bottom: 2.5rem;
      width: 20rem;
    }

    footer{
      margin-top: 8vw;
    }

    footer .contenedor-letras-logo {
      right: 0;
      left: -12rem;
    }

    footer p.abriendo-juego {
      font-size: 1.5rem;
    }

    footer p.colectivo {
      font-size: 1rem;
    }

  }

</style>


